<a
  data-testid="dropdown-toggle"
  [ngClass]="[type, showDropdown ? 'dropdown-toggle active' : 'dropdown-toggle']"
  (click)="toggleDropdown()"
  (touchStart)="toggleDropdown()"
></a>
<div
  data-testid="dropdown"
  class="dropdown"
  [ngClass]="{ active: showDropdown }"
  (click)="dropdownClicked($event)"
  (touchStart)="dropdownClicked($event)"
>
  @for (group of devicesGroup | keyvalue; track group.key) {
    <div>
      <span class="dropdown-title"> Select {{ group.key }} </span>
      <div class="options">
        @for (device of group.value.devices; track device.deviceId) {
          <div class="option" (click)="optionChanged(group.key, device)" [attr.data-testid]="device.deviceId">
            <i class="check-icon">
              @if (isDeviceSelected(group.key, device)) {
                <svg
                  data-testid="check-icon"
                  width="11"
                  height="9"
                  viewBox="0 0 11 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.66602 1.08301L3.24935 7.49967L0.916016 5.16634"
                    stroke="white"
                    stroke-width="1.16667"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
            </i>
            <span
              class="option-name"
              [ngClass]="isDeviceSelected(group.key, device) || isChangingDevice ? 'option-disabled' : ''"
              >{{ device.label }}</span
            >
          </div>
        }
      </div>
    </div>
  }
  @if (canOverrideQuality()) {
    <div>
      <span class="dropdown-title"> camera resolution</span>
      <div class="options">
        @for (quality of presenterVideoQualityWithLabels; track quality) {
          <div class="option" (click)="onQualityOverride(quality.key)" [attr.data-testid]="quality.key">
            <i class="check-icon">
              @if (currentQuality === quality.key) {
                <svg
                  data-testid="check-icon"
                  width="11"
                  height="9"
                  viewBox="0 0 11 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.66602 1.08301L3.24935 7.49967L0.916016 5.16634"
                    stroke="white"
                    stroke-width="1.16667"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
            </i>
            <span
              class="option-name"
              [ngClass]="currentQuality === quality.key || isChangingDevice ? 'option-disabled' : ''"
              >{{ quality.labels[videoQualityLevelAvailable] }}</span
            >
          </div>
        }
      </div>
    </div>
  }
</div>
